import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';

export const NextGenEnterpriseCloudModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'}>
            <UiKit.Text.BodyRegularBold>
                To move forward with Autofulfill setup please complete the following items:
            </UiKit.Text.BodyRegularBold>
            <UiKit.Chakra.UnorderedList>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Verify your NextGen Enterprise version is higher than 5.9.0
                    </UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Confirm that NextGen API Suite Manager is installed on your NextGen Prod (NGPROD)
                        environment
                    </UiKit.Text.BodyRegular>
                    <UiKit.Chakra.UnorderedList styleType="circle">
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                If it isn’t, NextGen support will complete the setup free of charge. Follow
                                the
                                <UiKit.Text.Clickable
                                    onClick={() =>
                                        window.open(
                                            'https://www.community.nextgen.com/articles/Hot_Topic/NextGen-Enterprise-API',
                                            '_blank'
                                        )
                                    }
                                    text={' instructions '}
                                    color={UiKit.consistency.primaryBlue40}
                                    underline={true}
                                />
                                on NextGen’s community portal to set up NGPROD with API Suite Manager.
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                    </UiKit.Chakra.UnorderedList>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Send the below consent email to the NextGen API team at apipartners@nextgen.com
                    </UiKit.Text.BodyRegular>
                    <UiKit.Chakra.UnorderedList styleType="circle">
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.ExternalLink
                                href="/df/consent-template.pdf"
                                text="Consent Email Template"
                            />
                        </UiKit.Chakra.ListItem>
                    </UiKit.Chakra.UnorderedList>
                </UiKit.Chakra.ListItem>
            </UiKit.Chakra.UnorderedList>
            <UiKit.Text.BodyRegular>
                Our team will reach out with next steps once we are ready to proceed with implementation.
                Thank you!
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Close'} onClick={props.onClose} />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue Autofulfill Set Up'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'3xl'}
            fullScreen={false}
        />
    );
};
